// Revival — one way to read and print a quote, shared by every Revival screen.
// - Every live quote comes from GET /revival/ (QuoteListCreateView: tenant-scoped,
//   is_deleted excluded). The scanner's recent/?limit= endpoint is a page, not a
//   count: the Planner showed "Quotes Extracted 12" because it counted a 12-row page.
// - Unknown is "—", never $0.00 (Design Standard: EmptyState). A real 0 stays $0.00.
// - "Date on ticket" is document_date once OPS's leg 19 ships; until then the
//   scanner saved it as quote_date.

export const rowsOf = (value) =>
  Array.isArray(value) ? value : Array.isArray(value?.results) ? value.results : [];

const n = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const v = Number(value);
  return Number.isFinite(v) ? v : null;
};

/** "$2,552,712.13", or "—" when unknown. */
export const money = (value) => {
  const v = n(value);
  return v === null ? "—" : v.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

/** "$2,552,712" for headline totals, or "—". */
export const moneyWhole = (value) => {
  const v = n(value);
  return v === null ? "—" : v.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
};

export const count = (value) => {
  const v = n(value);
  return v === null ? "—" : v.toLocaleString("en-US");
};

/** The quote's value as the quote screen (QuoteDetail) and the scanner summary
 *  read it: estimated_total, then total. null when neither is set. On t6, 9 of 295
 *  scanned quotes disagree between the two (Q-0239: total $2,893,825.00 with no
 *  lines, estimated $0) — reported to OPS, not smoothed over here. */
export const quoteTotal = (q) => n(q?.estimated_total) ?? n(q?.total);

/** ISO date written on the paper, or "" when the ticket had none. */
export const ticketDateOf = (q) => String(q?.document_date || q?.quote_date || "").slice(0, 10);

export const shortDate = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ""));
  if (!m) return "—";
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const addressOf = (q) => [q?.address, q?.city].map((s) => String(s || "").trim()).filter(Boolean).join(", ");

const SOURCE = { scanner: "Scanned", manual: "Manual", import: "Import", ai: "AI", composer: "Composer" };
export const sourceLabel = (s) => SOURCE[s] || (s ? String(s).replace(/_/g, " ") : "—");

const STATUS = {
  draft: ["Draft", "neutral"],
  sent: ["Sent", "info"],
  viewed: ["Viewed", "info"],
  accepted: ["Accepted", "success"],
  converted: ["Converted", "success"],
  active: ["Active", "info"],
  completed: ["Completed", "success"],
  rejected: ["Rejected", "danger"],
  renewal_due: ["Renewal due", "warning"],
};
export const statusLabel = (s) => (STATUS[s] || [s ? String(s).replace(/_/g, " ") : "Draft"])[0];
export const statusTone = (s) => (STATUS[s] || [null, "neutral"])[1];
